import { z } from '@harvestiq/zod';
import { dbClaimDocumentSchema } from './db-claim-documents';

export const claimDocumentWithDownloadUrlSchema = dbClaimDocumentSchema.extend({
  downloadUrl: z.string().url(),
});

export type ClaimDocumentWithDownloadUrl = z.infer<
  typeof claimDocumentWithDownloadUrlSchema
>;
